module.exports = __webpack_public_path__ + "static/media/Rimbayu-Starling Type D - 03-min.1b8413ae.jpg";